/**
 * Teslimat bölgesi çubuğu + koleksiyon ürün filtresi.
 *
 * NE YAPAR
 *  1. Sayfanın üstünde müşterinin teslimat adresini seçtiği bir çubuk gösterir.
 *  2. Adres seçilince listelenen ürünleri süzer: o adrese GÖNDERİLEMEYEN
 *     ürünler gizlenir. Müşteri sipariş veremeyeceği bir ürünü görmemeli.
 *  3. Kurye ile aynı gün gidebilen ürünlerin görselinin altında, başlığın
 *     üstünde yeşil "Aynı Gün Teslimat" rozeti gösterir.
 *
 * KURAL TABLOSU (ürünün teslimat modu × bayinin o adrese çıkıp çıkmaması)
 *
 *   mod                | bayi çıkıyor        | bayi çıkmıyor
 *   -------------------|---------------------|------------------
 *   cargo_only         | görünür, rozet yok  | görünür, rozet yok
 *   courier_and_cargo  | görünür + ROZET     | görünür, rozet yok
 *   courier_only       | görünür + ROZET     | GİZLENİR
 *
 * Yalnızca "courier_only" ürünler gizlenir; diğerleri kargoyla da gidebildiği
 * için bölge dışında da satılabilir.
 *
 * ADRES DURUMU AGT WIDGET'IYLA ORTAK
 * Ürün sayfasındaki teslimat widget'ıyla aynı localStorage anahtarlarını
 * kullanır ve aynı olayı (localDeliveryLocationChanged) hem yayar hem dinler.
 * Böylece müşteri adresini nerede değiştirirse değiştirsin iki taraf da
 * aynı şeyi gösterir.
 */
(function () {
  if (window.__tmDeliveryBar) return;
  window.__tmDeliveryBar = true;

  var PROXY = "/apps/local-delivery";

  var STORE_CITY = "local_delivery_city";
  var STORE_DISTRICT = "local_delivery_district";
  var STORE_NEIGHBORHOOD = "local_delivery_neighborhood";

  // Sitenin adres ekranındaki "Standart Kargo ile Devam Et" düğmesi ilçeyi
  // bu değerle kaydediyor (bkz. AGT widget'ında queryFullLocation("İstanbul",
  // "Kargo", "Kargo")). Gerçek bir ilçe değil, "bölge dışındayım" işareti -
  // ekranda ilçe adı gibi göstermemek ve boşuna bölge sorgusu atmamak için
  // ayrıca tanıyoruz.
  var OUTSIDE = "Kargo";

  var state = {
    city: "",
    district: "",
    neighborhood: "",
    filterOn: true,
    // { "Bayi Adı": true|false } - bu adrese kurye çıkıyor mu
    vendorCoverage: {},
    products: []
  };

  var els = {};

  // ---------------------------------------------------------------- yardımcı

  function read(key) {
    try {
      return localStorage.getItem(key) || "";
    } catch (e) {
      return "";
    }
  }

  function getJson(path, params) {
    var qs = Object.keys(params)
      .filter(function (k) {
        return params[k] !== "" && params[k] != null;
      })
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(params[k]);
      })
      .join("&");

    return fetch(PROXY + path + (qs ? "?" + qs : ""), { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function hasAddress() {
    return Boolean(state.city && state.district);
  }

  function isOutside() {
    return state.district === OUTSIDE || state.neighborhood === OUTSIDE;
  }

  // -------------------------------------------------------- native filtre

  /**
   * Kullanıcı planı (2026-09-24): tüm ürünleri çekip JS ile gizlemek yerine,
   * koleksiyon sayfasını Shopify'ın NATIVE etiket filtresiyle (?filter.p.tag=)
   * yeniden yükleyerek baştan sadece uygun ürünleri getiriyoruz. Aşağıdaki
   * uygulama, ilçe adını Laravel'in Str::slug()'ıyla BİREBİR aynı sonucu
   * verecek şekilde çeviriyor - bkz. CourierDistrictTagSync (PHP tarafı).
   * Bu, aşağıdaki applyToProducts()'un yaptığı ince (mahalle bazlı) gizlemeyi
   * DEĞİŞTİRMİYOR, sadece önüne çok daha küçük bir ürün kümesi koyuyor.
   */
  var TAG_CARGO_OK = "kargo-uygun";
  var TAG_ALL_ISTANBUL = "kurye-tum-istanbul";
  var TAG_DISTRICT_PREFIX = "kurye-ilce-";

  var TURKISH_FOLD = {
    ı: "i", İ: "i", ş: "s", Ş: "s", ğ: "g", Ğ: "g",
    ü: "u", Ü: "u", ö: "o", Ö: "o", ç: "c", Ç: "c"
  };

  function slugifyDistrict(name) {
    var folded = String(name || "")
      .split("")
      .map(function (ch) { return TURKISH_FOLD[ch] || ch; })
      .join("")
      .toLowerCase();

    return folded.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  /** @return {string[]} boşsa: filtre uygulanmasın (adres seçilmemiş). */
  function desiredCollectionTags() {
    if (!hasAddress()) return [];
    if (isOutside()) return [TAG_CARGO_OK];

    return [TAG_CARGO_OK, TAG_ALL_ISTANBUL, TAG_DISTRICT_PREFIX + slugifyDistrict(state.district)];
  }

  function sameSet(a, b) {
    if (a.length !== b.length) return false;
    var sa = a.slice().sort();
    var sb = b.slice().sort();
    for (var i = 0; i < sa.length; i++) {
      if (sa[i] !== sb[i]) return false;
    }
    return true;
  }

  function isManagedTag(tag) {
    return tag === TAG_CARGO_OK || tag === TAG_ALL_ISTANBUL || tag.indexOf(TAG_DISTRICT_PREFIX) === 0;
  }

  /**
   * Gerekirse koleksiyon sayfasını doğru etiket filtresiyle yeniden yükler.
   * Sadece BİZİM yönettiğimiz etiketleri (bkz. isManagedTag) ekler/kaldırır -
   * müşterinin ya da temanın kendi filtre seçimlerine dokunmaz.
   *
   * @return {boolean} true ise yönlendirme tetiklendi (çağıran taraf devam etmemeli).
   */
  function syncCollectionFilterUrl() {
    if (!/^\/collections\//.test(window.location.pathname)) return false;
    if (typeof URLSearchParams === "undefined") return false;

    var desired = desiredCollectionTags();
    var params = new URLSearchParams(window.location.search);
    var existing = params.getAll("filter.p.tag");
    var others = existing.filter(function (t) { return !isManagedTag(t); });
    var current = existing.filter(isManagedTag);

    if (sameSet(current, desired)) return false;

    params.delete("filter.p.tag");
    others.concat(desired).forEach(function (t) { params.append("filter.p.tag", t); });

    // Filtre değişince ürün kümesi (ve dolayısıyla sayfa sayısı) değişir -
    // eski "page" parametresi yeni kümede artık geçersiz olabilir (ör.
    // kargo-uygun'da 200 ürünün 3. sayfasındayken kuryeli bir ilçeye geçmek,
    // o ilçede sadece 1 sayfalık ürün varsa Shopify'dan 404 döndürüyordu).
    // Filtre değiştiğinde her zaman 1. sayfaya dönülür.
    params.delete("page");

    var qs = params.toString();
    window.location.replace(window.location.pathname + (qs ? "?" + qs : ""));

    return true;
  }

  // ------------------------------------------------------------ ürün kartları

  /**
   * Sayfadaki ürün kartlarını toplar.
   *
   * Kartlar Liquid tarafında `.tm-pd` işaretçisiyle etiketleniyor
   * (bkz. snippets/product-card-grid.liquid ve product-card-list.liquid);
   * bayi ve teslimat modu oradan okunuyor. Gizlerken kartın kendisini değil,
   * ızgara hücresini gizliyoruz - aksi halde boş hücreler kalıp düzen bozulur.
   */
  function collectProducts() {
    state.products = Array.prototype.map.call(document.querySelectorAll(".tm-pd"), function (marker) {
      return {
        vendor: (marker.getAttribute("data-tm-vendor") || "").trim(),
        mode: (marker.getAttribute("data-tm-mode") || "courier_and_cargo").trim(),
        cell: marker.closest(".gitem, .lv_item") || marker.closest(".grid_bx") || marker.parentElement,
        badge: null
      };
    });

    state.products.forEach(function (item) {
      if (!item.cell) return;
      item.badge = item.cell.querySelector(".tm-sameday");
    });
  }

  /** Sayfadaki farklı bayiler - bölge sorgusu bayi başına bir kez atılır. */
  function vendorsOnPage() {
    var seen = [];
    state.products.forEach(function (item) {
      if (item.vendor && seen.indexOf(item.vendor) === -1) seen.push(item.vendor);
    });
    return seen;
  }

  /**
   * Her bayi için "bu adrese kurye çıkıyor mu" sorar.
   * Bölge dışı seçildiyse hiç sormaya gerek yok - hiçbiri çıkmıyor.
   */
  function loadVendorCoverage() {
    state.vendorCoverage = {};

    if (!hasAddress() || isOutside()) {
      return Promise.resolve();
    }

    var vendors = vendorsOnPage();

    return Promise.all(
      vendors.map(function (vendor) {
        return coverageFor(vendor).then(function (covered) {
          state.vendorCoverage[vendor] = covered;
        });
      })
    );
  }

  /**
   * Bir bayi bu adrese çıkıyor mu?
   *
   * Mahalle seçildiyse check-location, seçilmediyse check-district
   * kullanılıyor. Bu ayrım önemli: check-location'daki joker BÖLGE TARAFINDA
   * çalışıyor ("bu bayi tüm mahallelere çıkıyor"), sorgu tarafında değil.
   * Mahalle yerine "*" göndermek, mahalle bazlı bölge tanımlamış bir bayide
   * hiçbir zaman eşleşmez ve ürünleri haksız yere gizlerdik. İlçe sorusunun
   * doğru muhatabı check-district.
   */
  function coverageFor(vendor) {
    if (state.neighborhood) {
      return getJson("/check-location", {
        city: state.city,
        district: state.district,
        neighborhood: state.neighborhood,
        vendorName: vendor
      }).then(function (data) {
        return Boolean(data && data.matched);
      });
    }

    return getJson("/check-district", {
      city: state.city,
      district: state.district,
      vendorName: vendor
    }).then(function (data) {
      return Boolean(data && data.active);
    });
  }

  function vendorCovers(vendor) {
    return Boolean(state.vendorCoverage[vendor]);
  }

  /** Ürün bu adrese gönderilebilir mi? */
  function deliverable(item) {
    if (item.mode === "courier_only") {
      return vendorCovers(item.vendor);
    }
    return true;
  }

  /** Aynı gün rozeti gösterilsin mi? */
  function sameDay(item) {
    return item.mode !== "cargo_only" && vendorCovers(item.vendor);
  }

  /**
   * GERİ BESLEME DÖNGÜSÜ (2026-09-24 bulgusu): tema.js'deki jQuery tabanlı
   * sonsuz kaydırma, "sayfanın sonuna yaklaşıldı mı" kararını `.infinitpagin
   * a.infinite` var mı VE sayfanın görünür yüksekliği yeterli mi diye
   * veriyor. Aşağıdaki applyToProducts() courier_only ürünleri toplu
   * gizleyince (display:none) sayfa aniden küçülüyor - müşteri kurye
   * bölgesi dışındaysa (ör. Ankara) ve koleksiyonda çok sayıda courier_only
   * ürün varsa (Canlı Çiçekler örneği: Yonca Flower'ın 47 ürünü courier_only
   * yapılınca belirginleşti), müşterinin normal kaydırması bu küçülmüş
   * sayfada "sona yaklaşıldı" eşiğine olması gerekenden ÇOK daha sık
   * çarpıyor - art arda sayfa çekilip filtrelenip tekrar küçülüyor, ürünler
   * "gelip gidiyor" gibi görünüyor ve "Yükleniyor..." hiç bitmiyor.
   *
   * Çözüm: her gizleme geçişinden hemen sonra, tetikleyici linki (`.infinitpagin
   * a.infinite`) KISA bir süreliğine tema.js'in seçicisiyle eşleşmeyecek
   * şekilde işaretliyoruz (`infinite` sınıfını geçici kaldırıyoruz). Bu
   * sürede kaç kaydırma olursa olsun tema.js'in kontrolü boş döner - sayfa
   * yerleşimi gerçekten yerine oturana kadar erken/art arda yükleme
   * tetiklenmez. Süre dolunca sınıf geri konur, tema normal şekilde devam eder.
   */
  var AUTO_LOAD_COOLDOWN_MS = 500;
  var autoLoadCooldownTimer = null;

  function suppressAutoLoadBriefly() {
    var trigger = document.querySelector(".infinitpagin a.infinite");
    if (!trigger) return;

    clearTimeout(autoLoadCooldownTimer);
    trigger.classList.remove("infinite");
    trigger.setAttribute("data-tm-suppressed", "true");

    autoLoadCooldownTimer = setTimeout(function () {
      document.querySelectorAll('.infinitpagin a[data-tm-suppressed="true"]').forEach(function (el) {
        el.classList.add("infinite");
        el.removeAttribute("data-tm-suppressed");
      });
    }, AUTO_LOAD_COOLDOWN_MS);
  }

  function applyToProducts() {
    var hidAny = false;

    state.products.forEach(function (item) {
      if (!item.cell) return;

      var canDeliver = !hasAddress() || deliverable(item);
      var hide = state.filterOn && hasAddress() && !canDeliver;

      if (hide && !item.cell.classList.contains("tm-hidden-product")) hidAny = true;
      item.cell.classList.toggle("tm-hidden-product", hide);

      if (item.badge) {
        // Sınıf değil `hidden` özniteliği: bu CSS dosyası yalnızca section'ın
        // olduğu sayfada yükleniyor, rozet ise tüm koleksiyonların kartlarında
        // basılı. Gizliliği tarayıcının kendi kuralına bırakmak, section'sız
        // sayfalarda rozetin düz metin olarak sızmasını engelliyor.
        item.badge.hidden = !(hasAddress() && sameDay(item));
      }
    });

    if (hidAny) suppressAutoLoadBriefly();
  }

  // ------------------------------------------------------------------- çubuk

  function renderBar() {
    if (!els.root) return;

    els.root.setAttribute("data-has-address", hasAddress() ? "true" : "false");

    if (!hasAddress()) {
      els.root.setAttribute("data-state", "empty");
      els.address.textContent = els.root.getAttribute("data-empty-title") || "Nereye teslim edilecek?";
      els.note.textContent = els.root.getAttribute("data-empty-note") || "Adresinizi seçin, size ulaşabilen ürünleri gösterelim.";
      els.change.textContent = "Adres Seç";
      els.label.textContent = "Teslimat Adresi";
      return;
    }

    var anyCourier = Object.keys(state.vendorCoverage).some(function (v) {
      return state.vendorCoverage[v];
    });

    els.label.textContent = "Teslimat Adresi";
    els.change.textContent = "Değiştir";

    if (isOutside()) {
      els.root.setAttribute("data-state", "cargo");
      els.address.textContent = state.city + " · Diğer bölgeler";
      els.note.textContent = "Bu adres aynı gün kurye bölgemizin dışında. Kargoyla gönderilebilen ürünleri görüyorsunuz.";
      return;
    }

    var parts = [state.city, state.district];
    if (state.neighborhood && state.neighborhood !== "*") parts.push(state.neighborhood);
    els.address.textContent = parts.join(" / ");

    if (anyCourier) {
      // Kurye çıkıyorsa ek açıklama yazmıyoruz: yeşil kart ve ürünlerdeki
      // rozetler zaten bunu söylüyor, tekrar etmek gürültü.
      els.root.setAttribute("data-state", "courier");
      els.note.textContent = "";
    } else {
      els.root.setAttribute("data-state", "cargo");
      els.note.textContent = "Bu adrese aynı gün kurye çıkmıyor, siparişiniz kargo ile gönderilir.";
    }
  }

  function refresh() {
    return loadVendorCoverage().then(function () {
      renderBar();
      applyToProducts();
    });
  }

  // ------------------------------------------------------------ adres seçici

  /**
   * Adres seçimi SİTENİN KENDİ ekranıyla yapılıyor - AGT teslimat
   * uygulamasının açtığı modal (#local-delivery-modal-overlay).
   *
   * Neden burada ayrı bir seçici yok: müşteri adresini iki farklı ekranla
   * seçerse iki farklı davranış öğrenir. Üstelik o ekran sepette ürün varken
   * "adresi değiştirmek için sepeti boşaltmanız gerekiyor" kuralını da
   * uyguluyor; kendi seçicimiz o kuralı atlardı.
   *
   * Yüzen rozete tıklıyoruz (gizli olsa bile .click() dinleyiciyi çalıştırır),
   * çünkü sepet kontrolü o dinleyicinin içinde.
   */
  function openPicker() {
    var badge = document.getElementById("local-delivery-float-badge");

    if (badge) {
      badge.click();
      return;
    }

    // Rozet yoksa (uygulama gömülüsü kapalıysa) doğrudan modalı açmayı dene.
    var overlay = document.getElementById("local-delivery-modal-overlay");

    if (overlay) {
      overlay.classList.add("active");
      return;
    }

    console.warn("Teslimat adresi ekranı bulunamadı: AGT uygulama gömülüsü açık mı?");
  }

  // -------------------------------------------------------------- başlatıcı

  function bind() {
    els.root = document.querySelector(".tm-db");
    if (!els.root) return false;

    els.label = els.root.querySelector(".tm-db__label");
    els.address = els.root.querySelector(".tm-db__address");
    els.note = els.root.querySelector(".tm-db__note");
    els.change = els.root.querySelector(".tm-db__change");

    els.change.addEventListener("click", openPicker);
    els.card = els.root.querySelector(".tm-db__card");
    els.card.addEventListener("click", function (e) {
      // Kartın herhangi bir yerine tıklamak da adres ekranını açsın -
      // mobilde küçük butonu bulmak zor.
      if (e.target !== els.change) openPicker();
    });

    return true;
  }

  function init() {
    state.city = read(STORE_CITY);
    state.district = read(STORE_DISTRICT);
    state.neighborhood = read(STORE_NEIGHBORHOOD);

    // Önce native filtreyi kontrol et - yönlendirme tetiklendiyse (sayfa
    // zaten yeniden yükleniyor) burada durmanın anlamı yok.
    if (syncCollectionFilterUrl()) return;

    if (!bind()) return;

    // Gizleme yönetici ayarından açılıp kapatılıyor; müşteriye anahtar
    // gösterilmiyor.
    state.filterOn = els.root.getAttribute("data-filter-default") !== "off";

    collectProducts();
    renderBar();
    refresh();

    // Adres ürün sayfasındaki widget'tan değiştirilirse burayı da tazele.
    document.addEventListener("localDeliveryLocationChanged", function (e) {
      if (e.detail && e.detail.source === "tm-delivery-bar") return;

      state.city = read(STORE_CITY);
      state.district = read(STORE_DISTRICT);
      state.neighborhood = read(STORE_NEIGHBORHOOD);

      if (syncCollectionFilterUrl()) return;

      refresh();
    });

    // Sonsuz kaydırma / "daha fazla yükle" ile gelen kartlar da süzülmeli.
    var grid = document.querySelector("#collectionPr");
    if (grid && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () {
          collectProducts();
          applyToProducts();
        }, 120);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
